export const ProductsNavIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="products">
    <path stroke="#8E33FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M11.66 14.167h2.5m2.5 0h-2.5m0 0v-2.5m0 2.5v2.5"></path>
    <path
      stroke="#8E33FF"
      strokeWidth="1.5"
      d="M3.334 7.733v-3.8a.6.6 0 0 1 .6-.6h3.8a.6.6 0 0 1 .6.6v3.8a.6.6 0 0 1-.6.6h-3.8a.6.6 0 0 1-.6-.6ZM3.334 16.067v-3.8a.6.6 0 0 1 .6-.6h3.8a.6.6 0 0 1 .6.6v3.8a.6.6 0 0 1-.6.6h-3.8a.6.6 0 0 1-.6-.6ZM11.667 7.733v-3.8a.6.6 0 0 1 .6-.6h3.8a.6.6 0 0 1 .6.6v3.8a.6.6 0 0 1-.6.6h-3.8a.6.6 0 0 1-.6-.6Z"
    ></path>
  </svg>
);
